import { CompanyRevenueDtoPeriodEnum, CompanyType } from '@@types/api.types';
import { CompanyFormData } from '@schemas/company.schema';
import { formOptions } from '@tanstack/react-form';

export const companyFormOptions = formOptions({
  defaultValues: {
    city: '',
    cmmcLevel: undefined,
    country: 'US',
    description: '',
    hasForeignAffiliation: false,
    hasFunding: false,
    name: '',
    previousGovernmentWorkCountries: [],
    previousGovernmentWorkServiceIds: [],
    researchOrganizationData: {
      departmentHeadContact: {
        email: '',
        name: '',
      },
      departmentName: '',
      foreignAffiliates: [],
      funding: {
        countries: [],
        type: undefined,
      },
      ipLicense: undefined,
      techTransferContact: {
        email: '',
        name: '',
      },
      type: undefined,
    },
    revenue: {
      amount: undefined,
      period: CompanyRevenueDtoPeriodEnum.PerYear,
      valuation: undefined,
    },
    samsUeiNumber: '',
    state: '',
    type: CompanyType.COMMERCIAL,
    urls: {
      crunchbase: '',
      linkedin: '',
      twitter: '',
      website: '',
    },
    yearFounded: undefined,
  } as CompanyFormData,
});
